import RouterView from '@/page/main/DefaultRouterView'
import Create from '@/page/notice/create'
import List from '@/page/notice/list'
import MyList from '@/page/notice/myList'

export default {
  path: '/Notice',
  component: RouterView,
  children: [{
      path: 'Create/:id?',
      meta: {
        type: ['notice', 'create'],
        title: '新建通知公告'
      },
      component: Create
    },
    {
      path: 'List',
      meta: {
        type: ['notice', 'list'],
        title: '通知公告列表'
      },
      component: List
    },
    {
      path: 'MyList',
      meta: {
        type: ['notice', 'mylist'],
        title: '与我有关的通知公告'
      },
      component: MyList
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/notice.js